<template>
  <v-app>
    <router-view></router-view>
  </v-app>
</template>

<script>
export default {
  name: 'app',
  beforeCreate() {
    const lang = this.$route.path.split('/')[1];
    if (lang !== 'en' && lang !== 'de') {
      return;
    }
    this.$lang.setLang(lang);
    this.$cookie.set('lang', lang, { expires: '8h' });
  },
};
</script>

<style lang="scss">
  #app {
    height: 100vh;
    background: #eee;
    overflow-x: hidden;
    font-family: 'Lato', sans-serif;
  }
  html {
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto !important;
  }
  th {
    outline: none;
  }
  .btn {
    &--outline {
      border: 1px solid rgba(0, 0, 0, 0.2) !important;
    }
  }
  .vdatetime-popup__header {
    background: #FFB300 !important;
  }
  .vdatetime-calendar__month__day--selected > span > span,
  .vdatetime-calendar__month__day--selected:hover > span > span {
    background: #FFB300 !important;
  }
  .vdatetime-popup__actions__button {
    color: #FFB300 !important;
  }
  .vdatetime-input {
    cursor: pointer;
    text-align: center;
  }
  .vdatetime-time-picker__item--selected {
    color:#FFB300 !important;
  }
  .search {
    padding-top: 16px;
    height: 50px;
    a {
      &:hover{
        background: none !important;
      }
    }
  }
  .datetime-btn {
    -moz-user-select: none;
    -ms-user-select: none;
    -webkit-user-select: none;
    align-items: center;
    border-radius: 2px;
    display: inline-flex;
    flex: 0 0 auto;
    font-size: 14px;
    height: 36px;
    justify-content: center;
    margin: 0;
    min-width: 88px;
    outline: 0;
    position: relative;
    text-decoration: none;
    text-transform: uppercase;
    transition: .3s cubic-bezier(.25,.8,.5,1),color 1ms;
    user-select: none;
    vertical-align: middle;
    background: transparent!important;
    border: 1px solid;
    box-shadow: none;
    input {
      padding: 0 16px;
    }
  }
  hr {
    height: 2px;
    background-color: #FFB300;
    width: 100%;
    border: none;
  }
  .vdatetime {
    ::placeholder {
      color: #FFB300;
      opacity: 1;
    }
    :-ms-input-placeholder {
      color: #FFB300;
    }
    ::-ms-input-placeholder {
      color: #FFB300;
    }
  }
  .v-input {
    margin-top: 0 !important;
  }
  .v-input label {
    font-size: 17px;
    &::after {
      color: #b71c1c !important;
    }
  }
  .menu__content {
    z-index: 204 !important;
  }
  .option {
    width: 100%;
    align-items: center;
    min-width: 300px;
    position: relative;
    label {
      position: relative !important;
      left: 0;
      max-width: 90% !important;
      width: fit-content;
      overflow: hidden;
      text-overflow: inherit !important;
      height: auto !important;
      line-height: inherit !important;
      white-space: inherit !important;
      z-index: 0;
      padding-top: 4px !important;
    }
    .input-group__input {
      position: absolute !important;
      left: 0;
      height: 100%;
      width: 100%;
      flex: 0;
    }
    .icon--selection-control {
      justify-content: flex-start !important;
      width: 100% !important;
      height: 100% !important;
      z-index: 5;
    }
  }
  .w-100 {
    width: 100%;
  }
  .max-w {
    max-width: 320px;
  }
  .min-w {
    min-width: 180px !important;
  }
  .min-w-lg {
    min-width: 280px;
  }
  .menu__content {
    z-index: 20;
    max-height: 450px;
    .list__tile {
      height: 36px;
    }
  }
  a {
    outline: none;
  }

  input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 30px #EDEDEE inset;
    box-shadow: 0 0 0 30px #EDEDEE inset;
  }

  // Animation
  .fade-enter {
    opacity: 0;
  }
  .fade-enter-active {
    transition: opacity 325ms ease-in;
  }
  .fade-leave-active {
    opacity: 0;
    transition: opacity 225ms ease-out;
  }

  .fade-down-enter {
    opacity: 0;
    transform: translateY(10px);
  }
  .fade-down-enter-active {
    transition: all 125ms ease-in;
    transform: translateY(0);
  }
  .fade-down-leave-active {
    transition: all 225ms ease-out;
    opacity: 0;
    transform: translateY(10px);
  }
</style>



// WEBPACK FOOTER //
// App.vue?2a4fbe58